module.exports = __webpack_public_path__ + "assets/img/wsglq.8511ad53.png";